import { Component } from '@angular/core';

@Component({
  selector: 'vb-event-editor',
  templateUrl: './event-editor.component.html',
  styleUrls: ['./event-editor.component.scss'],
  standalone: false  //NOSONAR
})
export class EventEditorComponent {}
